<template>
  <div id="wrap">
    <div class="top" v-if="type == 3">
      <ul>
        <li @click="tab(index)" :class="{active : index===curId}" v-for="(item,index) in activeArr" :key="index">
          {{ item }}
        </li>
      </ul>
    </div>
    <div v-if="type != 3" @click="switchRight" class="switch_btn"><img :src="switchPic" alt=""></div>
    <swiper v-if="curId == 0" class="swiper-no-swiping" id="swiperContent" :options="swiperOption"
            style="height: calc(100vh - 190px)">
      <swiper-slide
        :class="{'swiper_active':data.id==resourceId}"
        :key="index + '_' + data.id + '_' + data.isFinish"
        v-for="(data,index) in resourceData"
        class="swiper_list">
        <!--      <img :class="{'actives':data.id==faceValue}" @click="sendMsg(data,data.id)" :src="img" alt="" />-->
        <div @click="sendMsg(data, index)" class="swiper_items">
          <img v-if="data.type == 1" :src="picture" alt=""/>
          <img v-if="data.type == 2" :src="doc" alt=""/>
          <img v-if="data.type == 3" :src="audio" alt=""/>
          <img v-if="data.type == 4" :src="video" alt=""/>
          <img v-if="data.type == 5" :src="doc" alt=""/>
          <!--<img v-if="data.resourceType == 3" :src="subject" alt="" />-->
          <img v-if="data.resourceType == 5" :src="testPic" alt=""/>
          <span v-if="data.resourceType != 3">{{ data.name }}</span>
          <div class="training" v-if="data.resourceType == 3">
            <span>{{ `业务` + (index + 1) }}</span>
            <p>{{ data.name ? data.name : '实操题' + data.id }}</p>
          </div>
          <img v-if="data.taskType === 1 && sign!='preview'" :src="data.isFinish === 1?isFinish:unFinish"
               class="is_finish_pic"/>
        </div>
      </swiper-slide>
      <!--<div class="swiper-button-prev" slot="button-prev">o
        <i class="el-icon-arrow-up"></i>
      </div>
      <div class="swiper-button-next" slot="button-next">
        <i class="el-icon-arrow-down"></i>
      </div>-->
    </swiper>
    <swiper v-if="curId == 1" class="swiper-no-swiping" id="swiperContent" :options="swiperOption"
            style="height: calc(100vh - 190px)">
      <swiper-slide
        v-for="(data, index) in resourceMyData"
        :key="index + '_' + data.id + '_' + data.isFinish"
        :class="{'swiper_active':data.id==resourceId}"
        class="swiper_list">
        <!--      <img :class="{'actives':data.id==faceValue}" @click="sendMsg(data,data.id)" :src="img" alt="" />-->
        <div @click="sendMsg(data, index)" class="swiper_items">
          <img v-if="data.type == 1" :src="picture" alt=""/>
          <img v-if="data.type == 2" :src="doc" alt=""/>
          <img v-if="data.type == 3" :src="audio" alt=""/>
          <img v-if="data.type == 4" :src="video" alt=""/>
          <img v-if="data.type == 5" :src="doc" alt=""/>
          <!--<img v-if="data.resourceType == 3" :src="subject" alt="" />-->
          <img v-if="data.resourceType == 5" :src="testPic" alt=""/>
          <span v-if="data.resourceType != 3">{{ data.name }}</span>
          <div class="training" v-if="data.resourceType == 3">
            <span>{{ `业务` + (data.indexs + 1) }}</span>
            <p>{{ data.name ? data.name : '实操题' + data.id }}</p>
          </div>
          <img v-if="data.taskType === 1 && sign!='preview'" :src="data.isFinish === 1?isFinish:unFinish"
               class="is_finish_pic"/>
        </div>
      </swiper-slide>
      <!--<div class="swiper-button-prev" slot="button-prev">
        <i class="el-icon-arrow-up"></i>
      </div>
      <div class="swiper-button-next" slot="button-next">
        <i class="el-icon-arrow-down"></i>
      </div>-->
    </swiper>
    <div class="task_num" v-if="curId == 0">共计{{ resourceData ? resourceData.length : 0 }}个任务</div>
    <div class="task_num" v-if="curId == 1">共计{{ resourceMyData ? resourceMyData.length : 0 }}个任务</div>
  </div>
</template>

<script>
import video from "../../../../static/images/sourceIcon/video.png";
import doc from "../../../../static/images/sourceIcon/file.png";
import testPic from '../../../../static/images/sourceIcon/testPaper.png'
import audio from "../../../../static/images/sourceIcon/audio.png";
import picture from "../../../../static/images/sourceIcon/pic.png";
import subject from "../../../../static/images/sourceIcon/testQuestions.png";
import switchPic from "../../../../static/images/study/icon/switch_vertical.png";
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
import {moduleId} from "../../../store/modules/courseDetail";
import * as api from "../../../api/courseApi"
import isFinishSrc from "../../../../static/images/study/icon/success.png"
import unFinishSrc from "../../../../static/images/study/icon/unfinished.png"
import {getQuery2object} from "@/utils/utils"

export default {
  name: "mySwiper",
  data() {
    return {
      video: video,
      doc: doc,
      testPic: testPic,
      audio: audio,
      picture: picture,
      subject: subject,
      switchPic: switchPic,
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        // spaceBetween: 5,
        // slidesPerGroup: 1,
        loop: false,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      activeArr: ['全部', '我的'],
      curId: 0,
      resourceMyData: [],
      isFinish: isFinishSrc,
      unFinish: unFinishSrc
    };
  },
  props: {
    type: {
      type: [Number, String],
      default: () => 1
    },
    catalogId: {
      type: [Number, String],
      default: () => 0
    },
    sign: {
      type: [Number, String],
      default: ''
    },
  },
  // props:['swiperData','resourceId'],
  // watch: {
  //     'resourceId':{
  //         handler(newValue) {
  //             this.faceValue = newValue;
  //         },
  //         deep: true
  //     },
  //     'swiperData':{
  //         handler(newValue) {
  //             if(newValue.length > 5){
  //                 console.log(111);
  //                 this.showNext = true;
  //             }else{
  //                 this.showNext = false;
  //             }
  //         },
  //         deep: true
  //     }
  // },
  computed: {
    ...mapState(moduleId, {
      resourceData: state => state.resourceData,
      swiperFlag: state => state.swiperFlag,
      resourceId: state => state.resourceId,
    }),
  },
  // watch:{
  //     resourceData(val){
  //         console.log(val);
  //         if(val.length === 0){
  //             console(1111);
  //             this.SET_NOTE(false);
  //         }
  //     }
  // },
  methods: {
    ...mapActions(moduleId, [
      "setSwiperFlag",
      "setCurrentResource",
      "setResourceId",
    ]),
    ...mapMutations(moduleId, [
      'SET_NOTE',
    ]),
    sendMsg(data, index) {
      this.setResourceId(data.id);
      this.setCurrentResource(data);
      this.$emit('getActiveIndex', index)
    },
    switchRight() {
      this.setSwiperFlag(!this.swiperFlag);
    },
    tab(index) {
      this.curId = index;
      if (this.curId == 1) {
        this.resourceMyData = [];
        if (this.catalogId == null) return;
        api.getMmTask(this.$route.query.id, this.catalogId, this.$route.query.classId).then(res=>{
    			if(res.code == 0){
    				this.resourceMyData = res.data;
    				this.resourceData.forEach((item,i)=>{
    					this.resourceMyData.forEach(v=>{
    						if(item.id == v.id){
    							v.indexs = i;
    						}
    					})
    				})
    			}else{
            this.$messageError(res.msg)
          }
        })
      } else if (this.curId == 0) {
        this.resourceMyData = [];
      }
    }
  },
  mounted() {
//	this.curId = this.num;
  }
};
</script>
<style lang="scss" scoped>
/*@media screen and (max-width: 1450px) {*/
/*  #swiperContent{*/
/*    height: 510px;*/
/*  }*/
/* .swiper_list{*/
/*   width: 168px;*/
/*   height: 90px !important;*/
/* }*/
/*}*/
/*@media screen and (min-width: 1450px) {*/
/*  #swiperContent{*/
/*    height: 570px;*/
/*  }*/
/*  .swiper_list{*/
/*    width: 168px;*/
/*    height: 96px !important;*/
/*  }*/
/*}*/

#wrap {
  width: 100%;
  height: 100%;
  position: relative;

  .switch_btn {
    width: 20px;
    height: 20px;
    float: right;
    margin-top: 10px;
    margin-right: 25px;
    margin-bottom: 20px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .swiper-toggle {
    position: absolute;
    top: 50%;
    left: -16px;
    width: 20px;
    height: 64px;
    margin-top: -32px;
    cursor: pointer;
    background: url("./img/open.png");
    background-size: 100% 100%;
  }

  .swiper-open {
    background: url("./img/close.png");
    background-size: 100% 100%;
  }

  #swiperContent {
    position: relative;
    width: 100%;
    height: calc(100% - 102px);
    /*padding: 16px 0;*/
    box-sizing: border-box;

    .swiper_list {
      width: 168px;
      height: 64px !important;
      padding: 0;
      margin: 10px auto !important;
      border-radius: 3px;
      cursor: pointer;
      border: 1px solid rgba(93, 153, 255, 1);

      .swiper_items {
        width: 100%;
        height: 100%;
        color: #5397F7;
        font-size: 12px;

        img {
          width: 32px;
          height: 32px;
          float: left;
          margin-left: 16px;
          margin-top: 18px;
        }

        span {
          width: 100px;
          height: 25px;
          margin-left: 6px;
          margin-top: 22px;
          float: left;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .is_finish_pic {
          width: 12px;
          height: 12px;
          position: absolute;
          right: 15px;
          top: 8px;
          margin: 0;
        }
      }

      .training {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 12px;
        /*align-items: center;*/
        span {
          height: 15px;
          margin-top: 9px;
          margin-left: 16px;
          color: #5397F7;
        }

        p {
          margin-left: 17px;
          margin-right: 17px;
          line-height: 17px;
          word-break: break-all;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }

    /deep/ .swiper-wrapper {
      padding: 16px 0;
      height: calc(100% - 32px);
      overflow-y: auto;
    }

    .swiper_active {
      color: #262628;
      border: 1px solid rgba(93, 153, 255, 1);
      box-shadow: 0px 0px 16px rgba(31, 86, 204, 1);
    }

    .swiper-button-prev, .swiper-button-next {
      position: absolute;
      top: inherit;
      left: 35%;
      width: 64px;
      height: 25px;
      background: #d0d0d0;
      border-radius: 4px;
      cursor: pointer;
      text-align: center;
      line-height: 25px;
      margin: 0;

      i {
        color: white;
        font-size: 20px;
      }
    }

    .swiper-button-prev {
      top: 0;
    }

    .swiper-button-next {
      bottom: 0;
    }
  }

  .task_num {
    border-top: 1px solid #DEDEDE;
    width: 100%;
    height: 50px;
    color: #5397F7;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
  }

  .top {
    overflow: hidden;
    border-bottom: 1px solid #5397F7;
    padding: 0 26px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    ul {
      li {
        float: left;
        color: #999999;
        font-size: 14px;
        cursor: pointer;
        padding: 0 16px;
      }

      li.active {
        position: relative;
        color: #5397F7;

        &:after {
          position: absolute;
          content: '';
          width: 28px;
          height: 2px;
          background: #5397F7;
          top: 24px;
          left: 17px;
        }
      }
    }

    .switch_btn {
      margin: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/subcomponent/swiper/index.vue